module.exports = __webpack_public_path__ + "static/img/planLeft2.dec3902.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/actionPlan/planLeft2.png
// module id = AkRa
// module chunks = 1